<script>
export default {
  name: 'ConfidenceBadge',
  props: {
    level: {
      type: String,
      required: true,
      validator: value =>
        ['Confirmed', 'Likely', 'Possible', 'Weak', 'Manual', 'Unknown'].includes(value),
    },
    reason: {
      type: String,
      default: '',
    },
  },
  computed: {
    // Neutral by default (n-slate tokens = dark-mode-aware); color ONLY the exception
    // (Weak = low-confidence / conflict) so amber LIVE remains the sole strong accent.
    badgeClass() {
      return this.level === 'Weak'
        ? 'bg-n-ruby-4 text-n-ruby-11'
        : 'bg-n-slate-3 text-n-slate-11';
    },
  },
};
</script>

<template>
  <span
    class="inline-flex items-center px-1.5 py-px rounded-full text-[10px] font-semibold tracking-wide whitespace-nowrap"
    :class="badgeClass"
    :title="reason || undefined"
  >
    {{ level }}
  </span>
</template>
